<div class="health-card">
  <!-- Bande décorative haut -->
  <div class="card-stripe"></div>

  <div class="card-body">
    <!-- Colonne gauche : infos -->
    <div class="card-info">
      <div class="card-header">
        <img class="card-logo" src="/images/logos/eyone.png" alt="Eyone" />
        <span class="card-title-main">PASSEPORT MÉDICAL</span>
      </div>

      <div class="card-fields">
        <div class="card-field">
          <span class="field-label">NOM</span>
          <span class="field-value">{{ card.lastName | uppercase }}</span>
        </div>
        <div class="card-field">
          <span class="field-label">PRÉNOM</span>
          <span class="field-value">{{ card.firstName }}</span>
        </div>
        @if (card.birthday) {
          <div class="card-field">
            <span class="field-label">DATE DE NAISSANCE</span>
            <span class="field-value">{{ card.birthday }}</span>
          </div>
        }
      </div>

      <div class="card-footer-label">{{ card.relationLabel }}</div>
    </div>

    <!-- Séparateur vertical -->
    <div class="card-divider"></div>

    <!-- Colonne droite : QR code -->
    <div class="card-qr">
      @if (card.loading) {
        <div class="qr-spinner"></div>
      } @else if (card.hasDocument && card.documentUrl) {
        <img
          class="qr-image"
          [src]="card.documentUrl"
          alt="QR code"
          (click)="downloadQrCode()"
          title="Cliquer pour télécharger"
        />
        <span class="qr-hint">Télécharger</span>
      } @else {
        <button
          class="qr-generate-btn"
          [disabled]="card.generating"
          (click)="onGenerateQrCode()"
        >
          @if (card.generating) {
            <span class="btn-spinner"></span>
            <span>Génération...</span>
          } @else {
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
              <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
              <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
              <rect x="5" y="5" width="3" height="3" fill="currentColor"/>
              <rect x="16" y="5" width="3" height="3" fill="currentColor"/>
              <rect x="5" y="16" width="3" height="3" fill="currentColor"/>
              <path d="M14 14H17V17H20V20H17V17H14V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Générer le QR</span>
          }
        </button>
      }
    </div>
  </div>

  <!-- Bande magnétique bas -->
  <div class="card-magnetic"></div>
</div>
